import React from 'react';
import * as styles from './TimelineItem.module.scss';
import classNames from 'classnames';

export interface TimelineItemProps {
	title: React.ReactNode;
	link?: string;
	classes?: string;
	icon: React.ReactNode;
}

const TimelineItem = (props: TimelineItemProps) => {
	const {title, icon, link, classes} = props;

	const className = classNames(styles.wrapper, classes);

	const Content = () => {
		return (
			<>
				<div className={classNames('icon', styles.icon)}>{icon}</div>
				<h3 className={classNames('title', styles.title)}>{title}</h3>
			</>
		);
	};

	if (!!link)
		return (
			<a
				href={link}
				{...(link.includes('http')
					? {target: '_blank', rel: 'noopener noreferrer'}
					: {})}
				className={className}>
				<Content />
			</a>
		);

	return (
		<div className={className}>
			<Content />
		</div>
	);
};

export default TimelineItem;
